import { create } from 'zustand'
import { Conversation, Message } from '@/types'

interface ChatState {
  conversations: Conversation[]
  selectedConversation: Conversation | null
  messages: Message[]
  isLoading: boolean
  profiles: Record<string, { id: string; fullName: string; email: string; phone?: string; lastLoginAt?: string }>
  setConversations: (conversations: Conversation[]) => void
  setSelectedConversation: (conversation: Conversation | null) => void
  setMessages: (messages: Message[]) => void
  addMessage: (message: Message) => void
  setLoading: (loading: boolean) => void
  setProfile: (userId: string, profile: any) => void
}

export const useChat = create<ChatState>((set) => ({
  conversations: [],
  selectedConversation: null,
  messages: [],
  isLoading: false,
   profiles: {},
  setConversations: (conversations) => set({ conversations }),
  setSelectedConversation: (selectedConversation) => set({ selectedConversation }),
  setMessages: (messages) => set({ messages: Array.isArray(messages) ? messages : [] }),
  addMessage: (message) => set((state) => ({ 
    messages: [...state.messages, message] 
  })),
  setLoading: (isLoading) => set({ isLoading }),
  setProfile: (userId, profile) => set((state) => ({ profiles: { ...state.profiles, [userId]: profile } }))
}))
